import React from 'react';

interface Props {
  ratingAvg: number | null | undefined;
  ratingCount: number | undefined;
  onClick?: () => void;
}

const ProductRatingSummary: React.FC<Props> = ({ ratingAvg, ratingCount, onClick }) => {
  if (!ratingCount) {
    return (
      <div className="pd-rating pd-rating--empty">
        <span className="pd-rating__stars">☆☆☆☆☆</span>
        <span className="pd-rating__text">Zatím bez hodnocení</span>
      </div>
    );
  }
  const avg = ratingAvg ?? 0;
  const fullStars = Math.round(avg);
  const stars = '★★★★★☆☆☆☆☆'.substring(5 - fullStars, 5 - fullStars + 5);
  return (
    <div className="pd-rating" onClick={onClick} role={onClick ? 'button' : undefined} tabIndex={onClick ? 0 : undefined}>
      <span className="pd-rating__stars" aria-hidden="true">{stars}</span>
      <span className="pd-rating__value">{avg.toFixed(1).replace('.', ',')}</span>
      <span className="pd-rating__count">({ratingCount} {plural(ratingCount, 'hodnocení', 'hodnocení', 'hodnocení')})</span>
    </div>
  );
};

function plural(n: number, one: string, few: string, many: string): string {
  if (n === 1) return one;
  if (n >= 2 && n <= 4) return few;
  return many;
}

export default ProductRatingSummary;
